import Vue from 'vue'
import Vuex from 'vuex'
import { getVideoNewsStatus, getOrderSum, cityTreeAsync } from '../utils/api';

Vue.use(Vuex)
let _vm = new Vue()

export default {
  state: {
    originUserDistTree: null,
    ADV_INDUSTRY: [], // 客户所属行业(企业,包含个人行业)
    ADV_PERSON_INDUSTRY: [], // 客户所属行业(仅个人)
    ADVERTMESSAGETYPE: [], // 系统消息类型
    ADVERTSLOTTIME: [],
    flowTypes: [], // 数据分析流量详情下拉列表
    totalPutSn: 0, // 用户累计投屏数
    ADVORDERSTATE: null,      // 订单状态类型
    hasNoReadMsg: [], // 是否存在未读消息
    videoStatusNews: {},
    orderTypes: [], // 投放方案
    advertTypes: [], // 广告类型
    orderSnTypes: [],
    discountList: [],
    isWifiPut: false,
    GGDICT1080: [], // 计费方式
    CONTENTPLAYTYPE: [], // 方案类型
    NEW_NO_PLAY_LABLE: [], //新禁播标签字典集合
  },
  mutations: {
    setWifiPutMode(state, data) {
      state.isWifiPut = data
    },
    setDiscountList(state, data) {
      state.discountList = data
    },
    setPutScreenNum(state, data) {
      state.totalPutSn = data
    },
    setUserDistTree(state, data) {
      state.originUserDistTree = data
    },
    setDictData(state, { dictName, data }) {
      state[dictName] = data
    },
    setDictDataV2(state, { dictName, data }) {
      state['GGDICT' + dictName] = data
    },
    changeMsgStatu(state, data) {
      state.hasNoReadMsg = data
    },
    pushStoreMsg(state, data) {
      state.hasNoReadMsg.push(data)
    },
    setVideoStatusNews(state, data) {
      state.videoStatusNews = data
    },
    setStoreKeyData(state, data) {
      state[data.key] = data.data
    },
    fillTreeChildren(state, data) {
      state.originUserDistTree.forEach(el => {
        if (el.code === data.pData.code) {
          el.children = data.list
        }
      })
    }
  },
  actions: {
    async getDiscountList({ commit }) {
      let response = await _vm.fetch('/boss/common/config/v2/getDiscountActivity', '', 'get')
      if (response) commit('setDiscountList', response.data || [])
    },
    async getUserDistTreeAll({ commit }) { // 获取全量的树数据
      let res = await cityTreeAsync()
      if (res && res.code === 0) {
        let arr = (res.data || {}).children || []
        let list = [] // 从全国开始的 处理下取出所有的城市集合, 只保留到城市的数据
        arr.forEach(el => {
          let elChd = el.children || []
          elChd.forEach(child => {
            child.children && child.children.forEach(chdChd => {
              delete chdChd.children
            })
          })
          list = list.concat(elChd)
        })
        commit('setUserDistTree', changeTreeData(list))
      }
    },
    async getUserDistTree({ commit }) { // 获取第一级全部城市
      let list = await getDistrictByLevel(3)
      list.length && commit('setUserDistTree', changeTreeData(list))
    },
    async reqDistTreeChild({ commit }, data) {
      let list = await getDistrictByLevel(data.levelNum, data.code)
      list.length && commit('fillTreeChildren', {
        pData: data, list: changeTreeData(list, data.ids)
      })
    },
    async getDictItemList({ commit }, code) {
      let res = await _vm.fetch('/boss/bp/v2/getDictItemList', { dictTypeCode: code }, 'get')
      if (res && res.code === 0) {
        commit('setDictData', { dictName: code, data: (res.data || []) })
      }
    },
    async getDictListV2({ commit }, code) {
      let res = await _vm.fetch('/dmp/dic/v1/queryDicByCode', { code: code }, 'get')
      commit('setDictDataV2', { dictName: code, data: res.data })
    },
    async getMsgTipStatu({ commit }) {
      let res = await _vm.fetch('/boss/message/v2/receiveMessages', '', 'get')
      if (res && res.code == _vm.successCode) {
        if (res.data && res.data.length > 0) {
          commit('changeMsgStatu', res.data.filter(el => el.isRead === 0))
        }
      }
    },
    async getVideoNewsStatusRes({ commit }) {
      let response = await getVideoNewsStatus()
      if (response && response.code == _vm.successCode) {
        commit('setVideoStatusNews', response.data || {})
      }
    },
    async getDictItemListFromUrl({ commit }, data) {
      let res = await _vm.fetch(data.url, '', 'get')
      if (res && res.code == _vm.successCode) {
        if (res.data) {
          commit('setStoreKeyData', {
            key: data.key, data: res.data || []
          })
        }
      }
    },
    async getPutOrderType({ commit }) {
      const res = await _vm.fetch('/customer2/menu/select/1000', '', 'get')
      if (res && res.code === _vm.successCode && res.data) {
        const data = (res.data || []).map(e => {
          e.label = e.remark
          return e
        })
        commit('setDictData', { dictName: 'orderTypes', data })
      }
    },
    async getContentPlayType({ commit, state }) {
      if (state.CONTENTPLAYTYPE.length > 0) return
      const res = await _vm.fetch('/dsp/content/v2/getContentPlayTypeDic', '', 'get')
      if (res && res.code === _vm.successCode && res.data) {
        const data = (res.data || []).map(e => {
          e.label = e.dictItemName
          e.value = e.dictItemCode
          return e
        })
        commit('setStoreKeyData', { key: 'CONTENTPLAYTYPE', data })
        return data
      }
    },
    async getAdvertType({ commit }) {
      const res = await _vm.fetch('customer2/menu/select/1001', '', 'get')
      if (res && res.code === _vm.successCode && res.data) {
        const data = (res.data || []).map(e => {
          e.label = e.remark
          return e
        })
        commit('setDictData', { dictName: 'advertTypes', data })
      }
    },
    async orderSum({ commit }, param) {
      const res = await getOrderSum(param)
      if (res && res.code === 0 && res.data) {
        commit('setPutScreenNum', res.data.deviceCount || 0)
        return res.data
      }
    }
  },
  getters: {
    // 这里如果需要处理下数据需要深拷贝下，不然每一步改变都会触发重新getters，出现问题
    userDistTree: state => state.originUserDistTree ? changeTreeData(JSON.parse(JSON.stringify(state.originUserDistTree))) : null,
  }
}

function changeTreeData(arr, ids, names) {
  return arr.map(el => {
    let code = el.code || el.districtCode || ''
    el.code = code
    el.ids = ids ? ids + '^^' + code : code
    el.names = names ? names + '^^' + el.districtValue : el.districtValue
    el.children = el.children || []
    if (el.children.length > 0) el.children = changeTreeData(el.children || [], el.ids, el.names)
    return el
  })
}


async function getDistrictByLevel(lv, pCode) { // 获取levelNum层级的数据列表 跨省市,  存在code是获取当前code的所有子集
  let url = pCode ? '/config/api/v3/region/district-tree' : '/config/api/v3/region/district-list'
  let opt = {
    deviceCode: '33554688', // 设备类型(屏-33554688，网关-83886336)
    putStatusCode: 0, // 可投状态，0-可投，1-不可投
    levelNum: lv //1:省级别 2:市级别 类推
  }
  if (pCode) opt.parentCode = pCode
  let res = await _vm.fetch(url, opt, 'get')
  return res && res.data || []
}
